export class Statocommessa {
  Nome: string;
  Codice: number;
  Descrizione: string;

  constructor(){
    this.Codice=0;
    this.Nome='';
    this.Descrizione='';
  }
}
